import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/job/${number | ':jobId'}/groups`;

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/groups`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/groups`;
